import React from 'react'
import About from './About.js'

const Home = () => {
  return (
    <>
<About />
    </>
  )
}

export default Home
